export default "__VITE_ASSET__8a8910ae__"